export default __webpack_public_path__ + "static/media/ministerio-01-white.b18a8bc3.svg";